import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaUserCircle, FaRobot, FaAngleDown } from "react-icons/fa";
import { RiSendPlane2Fill } from "react-icons/ri";
interface Category {
  id: number;
  name: string;
  title: string;
  icon_type: string;
  questions: Question[];
}
interface Answer {
  id: number;
  testo: string;
}
interface Question {
  id: number;
  text: string;
  testo: string;
  answers: Answer[];
  category: string | { id: number; name: string };
  question_answers: any[];
}
interface MessageOption {
  id: number;
  type: string;
  text: string;
  back?: MessageOption; // This allows us to track the back category or question
}
interface Message {
  text: string;
  sender: "user" | "bot";
  options?: MessageOption[];
}
interface FunctionsArray {
  functions: (string | null)[];
}
const Chatbot = () => {
  const [messages, setMessages] = useState<Message[]>([
    { text: "Ciao! Come posso aiutarti oggi?", sender: "bot" },
  ]);
  const [input, setInput] = useState<string>("");
  const [isOpen, setIsOpen] = useState(true); // State to handle chat visibility
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [functionsArray, setFunctionsArray] = useState< FunctionsArray["functions"] >([]);
  const [showVerificationSuccess, setShowVerificationSuccess] = useState(false);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [newEmail, setNewEmail] = useState<string>("");
const [emailChangeSuccess, setEmailChangeSuccess] = useState<boolean>(false);

  useEffect(() => {
    fetchCategories();
  }, []);
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSendMessage();
    }
  };
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/categories`
      );
      
      setCategories(response.data);
    } catch (err) {
      setError("Erreur lors de la récupération des catégories");
      console.error("Error fetching categories:", err);
    } finally {
      setLoading(false);
    }
  };
  const extractEmail = (text: string): string | null => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return text.match(emailRegex)?.[0] ?? null;
  };
  const sendOTP = async (email: string) => {
  try {
    // Vérifier si l'email existe
    const checkEmailResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/check-email/${email}`
    );

    if (!checkEmailResponse.data.success) {
      // Si l'email n'existe pas, afficher un message d'erreur
      setMessages([
        ...messages,
        { text: email, sender: "user" },
        {
          text: "L'email n'existe pas. Veuillez entrer un email valide.",
          sender: "bot",
        },
      ]);
      return;
    }

    // Si l'email existe, envoyer l'OTP
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/send-otp`,
      {
        email: email,
      }
    );

   
    return response.data;
  } catch (error) {
    throw error;
  }
};
  const [email, setEmail] = useState<string>("");

  const handleSendMessage = async () => {
    if (input.trim()) {
      // Mode vérification de code
      if (isVerified && !showVerificationSuccess) {
        await verifyOTP(input);
      }
      // Mode saisie email
      else if (
        functionsArray.length > 0 &&
        functionsArray[0] !== null &&
        !showVerificationSuccess
      ) {
        const emailInput = extractEmail(input);
  
        if (emailInput) {
          try {
            // Vérification de l'existence de l'email avant d'envoyer l'OTP
            const checkEmailResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/check-email`,
              { email: emailInput }
            );
  
            if (checkEmailResponse.data.success) {
              // Si l'email existe, envoyer l'OTP
              const otpResponse = await axios.post(
                `${process.env.REACT_APP_API_URL}/send-otp`,
                { email: emailInput }
              );
              
              // Si OTP envoyé avec succès, afficher un message
              setEmail(emailInput);
              setMessages([
                ...messages,
                { text: input, sender: "user" },
                {
                  text: "Merci pour votre email. Nous allons traiter votre demande.",
                  sender: "bot",
                },
              ]);
              setIsVerified(true);
              setInput("");
            } else {
              // Si l'email n'existe pas
              setMessages([
                ...messages,
                { text: input, sender: "user" },
                {
                  text: "Ce mail n'a pas de compte.",
                  sender: "bot",
                },
              ]);
              setInput("");
            }
          } catch (error) {
            console.error("Erreur lors de la vérification de l'email:", error);
            setMessages([
              ...messages,
              { text: input, sender: "user" },
              {
                text: "Il y a eu un problème avec la vérification de l'email. Veuillez réessayer.",
                sender: "bot",
              },
            ]);
            setInput("");
          }
        } else {
          // Si l'email est invalide
          setMessages([
            ...messages,
            { text: input, sender: "user" },
            {
              text: "Format d'email incorrect.",
              sender: "bot",
            },
          ]);
          setInput("");
        }
      }
      // Mode normal (catégories et questions)
      else {
        setMessages([
          ...messages,
          { text: input, sender: "user" },
          {
            text: "Merci pour votre message, nous vous répondrons bientôt.",
            sender: "bot",
          },
        ]);
        setInput("");
      }
    }
  };
   
  interface OtpResponse {
    success: boolean;
    message: string;
  }

 
const verifyOTP = async (code: string) => {
  try {
    // Validation du format du code OTP
    if (!/^\d{6}$/.test(code)) {
      setMessages([
        ...messages,
        { text: code, sender: "user" },
        {
          text: "❌ Le code doit être un nombre à 6 chiffres (entre 100000 et 999999)",
          sender: "bot",
        },
      ]);
      return;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/verify-otp`,
      {
        email: email,
        otp: parseInt(code),
      }
    );

    // Gestion des différents états de réponse
    const handleResponse = (response: OtpResponse) => {
      let botMessage = "";
      switch (response.message) {
        case "OTP validé avec succès":
            botMessage = "✅ Code de vérification confirmé avec succès !\nVeuillez entrer votre nouvel email :";
            setIsVerified(false);
            setShowVerificationSuccess(true);
            break;
        case "OTP incorrect":
          botMessage = "❌ Code de vérification invalide.";
          setIsVerified(false);
          setShowVerificationSuccess(false);
          break;
        case "OTP expiré ou non trouvé":
          botMessage = "⚠️ Code de vérification expiré ou non trouvé.";
          setIsVerified(false);
          setShowVerificationSuccess(false);
          // Réinitialiser les états pour revenir au mode message normal
          break;
        default:
          botMessage = response.message;
          setIsVerified(false);
          setShowVerificationSuccess(false);
      }

      setMessages([
        ...messages,
        { text: code, sender: "user" },
        { text: botMessage, sender: "bot" },
      ]);

      setInput("");
    };

    handleResponse(response.data);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage = error.response?.data.message || "Une erreur est survenue.";
      setMessages([
        ...messages,
        { text: code, sender: "user" },
        { text: `❌ ${errorMessage}`, sender: "bot" },
      ]);
      // Réinitialiser les états en cas d'erreur
      setIsVerified(false);
      setShowVerificationSuccess(false);
      setFunctionsArray([]);
    }
  }
};
const handleChangeEmail = async () => {
  if (!newEmail.trim()) {
    setMessages([
      ...messages,
      { text: newEmail, sender: "user" },
      {
        text: "Veuillez entrer un nouvel email.",
        sender: "bot",
      },
    ]);
    return;
  }

  const newEmailInput = extractEmail(newEmail);
  if (!newEmailInput) {
    setMessages([
      ...messages,
      { text: newEmail, sender: "user" },
      {
        text: "Format d'email invalide.",
        sender: "bot",
      },
    ]);
    return;
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/change-email`,
      {
        email: email,
        new_email: newEmailInput,
      }
    );

    setMessages([
      ...messages,
      { text: newEmail, sender: "user" },
      {
        text: "✅ Email modifié avec succès !",
        sender: "bot",
      },
    ]);

    // ✅ Réinitialisation des états après succès
    setEmailChangeSuccess(true);
    setNewEmail("");
    setShowVerificationSuccess(false); // Réinitialise le mode de saisie
    setInput(""); // Nettoie l'input
    setIsVerified(false); // Remet en mode normal
    setFunctionsArray([]); // Nettoie les fonctions spéciales
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage =
        error.response?.data.message || "Erreur lors du changement d'email.";
      setMessages([
        ...messages,
        { text: newEmail, sender: "user" },
        {
          text: `❌ ${errorMessage}`,
          sender: "bot",
        },
      ]);
    }
  }
};

  const logUserInteraction = async (interactionData: any) => {
   
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user-question-logs`,
        interactionData
      );
      console.log("Interaction enregistrée:", response.data); // Debugging line
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de l'interaction:", error);
    }
  };
  const onCategorySelected = async (category: Category) => {
    if (category.name.trim()) {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/questions?category_id=${category.id}`
        );
       
        
        setMessages([
          ...messages,
          { text: category.name, sender: "user" },
          {
            text: "Sto elaborando la tua richiesta...",
            sender: "bot",
            options: response.data.map((d: Question) => ({
              type: "question",
              text: d.text,
              id: d.id,
              back: category,
            })),
          },
        ]);
      } catch (error) {
        console.error("Erreur lors de la récupération des questions :", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const onQuestionSelected = async (question: MessageOption) => {
    setLoading(true);
    try {
      // Effectue la requête pour récupérer les réponses spécifiques à la question sélectionnée
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/answers?question_id=${question.id}`
      );
    
      setFunctionsArray(response.data[0]?.functions || []);

      const options = response.data.map((d: Answer) => ({
        type: "answer",
        text: d.testo, // Récupère le texte de chaque réponse
        id: d.id,
        back: question,
      }));
      // Si il n'y a pas de réponses, retourne à la sélection de catégories
      if (options.length === 0) {
        setMessages([
          ...messages,
          { text: question.text, sender: "user" },
          {
            text: "Sélectionner une catégorie",
            sender: "bot",
            options: categories.map((category) => ({
              type: "category",
              text: category.name,
              id: category.id,
            })),
          },
        ]);
      } else {
        setMessages([
          ...messages,
          { text: question.text, sender: "user" },
          {
            text:
              options.length > 1
                ? "Sto elaborando la tua richiesta..."
                : options[0].text,
            sender: "bot",
            options: options.length > 1 ? options : [],
          },
        ]);
      }
     
      const interactionData = {
        user_id: 3, // L'ID de l'utilisateur (à remplacer)
        category_id: question.back?.id,
        question: question.text,
        support_id: null,
      };
      logUserInteraction(interactionData);
    } catch (error) {
      console.error("Erreur lors de la récupération des réponses :", error);
    } finally {
      setLoading(false);
    }
  };
  const onAnswerSelected = async (answer: MessageOption) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/answers/${answer.id}?question_id=${answer.back?.id}`
      );
      const answerResp = response.data.answer;
      const nextQuestions =
        response.data.nextQuestions?.map((n: any) => n.next_question) || [];
      if (nextQuestions.length === 0) {
        setMessages([
          ...messages,
          { text: answer.text, sender: "user" },
          {
            text: "Merci pour vos réponses. Voulez-vous explorer d'autres catégories ?",
            sender: "bot",
            options: categories.map((category) => ({
              type: "category",
              text: category.name,
              id: category.id,
            })),
          },
        ]);
      } else {
        setMessages([
          ...messages,
          { text: answer.text, sender: "user" },
          {
            text: "Sto elaborando la tua richiesta...",
            sender: "bot",
            options: nextQuestions.map((d: Question) => ({
              type: "question",
              text: d.text,
              id: d.id,
              back: answer,
            })),
          },
        ]);
      }
      const interactionData = {
        user_id: 3, // L'ID de l'utilisateur (à remplacer)
        category_id: answer.back?.id,
        question: answer.text,
        support_id: null,
      };
      logUserInteraction(interactionData);
    } catch (error) {
      console.error("Erreur lors de la récupération des réponses :", error);
    } finally {
      setLoading(false);
    }
  };
  const onOptionSelected = (op: MessageOption) => {

    switch (op.type) {
      case "question":
        onQuestionSelected(op);
        break;
      case "answer":
        onAnswerSelected(op);
        break;
      case "category":
        setMessages([
          { text: "Ciao! Come posso aiutarti oggi?", sender: "bot" },
        ]);
        break;
      default:
        break;
    }
  };
  return isOpen ? (
    <div className="min-h-screen bg-gradient-to-r flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-lg overflow-hidden">
        <div className="flex justify-between items-center p-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
          <span className="text-left text-2xl font-semibold">Assistente</span>
          <button
            onClick={() => setIsOpen(false)}
            className="text-white hover:text-gray-300 transition-colors duration-200"
          >
            <FaAngleDown />
          </button>
        </div>
        <div className="h-[450px] overflow-y-auto p-4">
          {messages.map((message, index) => (
            <ChatBubble
              key={index}
              message={message}
              handleClick={onOptionSelected}
            />
          ))}
          {messages.length < 2 && !loading && (
            <div className="flex-1 overflow-y-auto">
              <div className="px-3 py-2">
                <div className="grid grid-cols-2 gap-3">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      className="flex flex-col items-center p-4 rounded-xl bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm border border-gray-100 group text-center h-20 justify-center"
                      onClick={() => onCategorySelected(category)}
                    >
                      <div className="text-center">
                        <div className="font-medium text-gray-900 mb-1">
                          {category.name}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
          {loading && (
            <div className="text-center text-gray-500">Caricamento...</div>
          )}
          {error && <div className="text-center text-red-500">{error}</div>}
          <div ref={messagesEndRef} />
        </div>
        <div className="flex p-1 bg-gray-200"></div>
        {functionsArray.length > 0 && functionsArray[0] !== null ? (
    <div className="flex p-4 bg-gray-200">
        <input
    type="email"
    value={showVerificationSuccess ? newEmail : input}
    onChange={(e) => {
        if (showVerificationSuccess) {
            setNewEmail(e.target.value);
        } else {
            setInput(e.target.value);
        }
    }}
    onKeyDown={handleKeyDown}
    placeholder={
        showVerificationSuccess
            ? "Entrez votre nouvel email..."
            : isVerified
                ? "Entrez votre code de vérification..."
                : "Entrez votre adresse email..."
    }
    className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-600"
/>
        <button
            onClick={() => {
                if (showVerificationSuccess) {
                    handleChangeEmail();
                } else {
                    handleSendMessage();
                }
            }}
            className="ml-2 bg-purple-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
        >
            <RiSendPlane2Fill size={20} />
        </button>
    </div>
) : (
    <div className="flex p-4 bg-gray-200">
        <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Écrivez un message..."
            className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-600"
        />
        <button
            onClick={handleSendMessage}
            className="ml-2 bg-purple-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
        >
            <RiSendPlane2Fill size={20} />
        </button>
    </div>
)}
      </div>
    </div>
  ) : null;
};

const ChatBubble: React.FC<{
  message: Message;
  handleClick: (op: MessageOption) => void;
}> = ({ message, handleClick }) => {
  const isUser = message.sender === "user";
  const formatTextWithLineBreaks = (text: string) => {
    return text.split("\n").map((str, index) => (
      <React.Fragment key={index}>
        {str}
        <br />
      </React.Fragment>
    ));
  };
  return (
    <div>
      <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4`}>
        {!isUser && (
          <div className="mr-2">
            <FaRobot className="text-gray-800 text-2xl" />
          </div>
        )}
        <div
          className={`p-3 max-w-xs rounded-lg text-white ${
            isUser ? "bg-indigo-400" : "bg-gray-400 text-black"
          } message-text`}
          style={{
            wordWrap: "break-word",
            whiteSpace: "pre-line",
            overflowWrap: "break-word",
          }}
        >
          {formatTextWithLineBreaks(message.text)}
        </div>
        {isUser && (
          <div className="ml-2">
            <FaUserCircle className="text-gray-800 text-2xl " />
          </div>
        )}
      </div>
      {message.options?.length ? (
        <div className={`${isUser ? "justify-end" : "justify-start"} mb-4`}>
          <div className="grid grid-cols-2 gap-2">
            {message.options?.map((op) => (
              <button
                key={op.id}
                className={`px-4 py-2 text-sm font-medium border-2 rounded-lg transition-all duration-300 transform hover:scale-105
        ${
          isUser
            ? "border-blue-500 text-blue-500 hover:bg-blue-50"
            : "border-gray-300 text-gray-700 hover:bg-gray-100"
        }`}
                onClick={() => handleClick(op)}
              >
                <span>{op.text}</span>
              </button>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default Chatbot;
